var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 100 100" },
      attrs: {
        version: "1.1",
        id: "Layer_2_copy_2",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("line", {
            staticClass: "st0",
            attrs: { x1: "86.863", y1: "50", x2: "13.137", y2: "50" },
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st0",
            attrs: { x1: "86.863", y1: "65.615", x2: "13.137", y2: "65.615" },
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st0",
            attrs: { x1: "86.863", y1: "34.385", x2: "13.137", y2: "34.385" },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "50", y1: "6.253", x2: "58.572", y2: "14.653" },
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "50", y1: "6.253", x2: "41.428", y2: "14.653" },
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "50", y1: "26.607", x2: "50", y2: "7.609" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("g", [
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "58.572", y1: "85.347", x2: "50", y2: "93.747" },
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "41.428", y1: "85.347", x2: "50", y2: "93.747" },
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "st0",
              attrs: { x1: "50", y1: "92.391", x2: "50", y2: "74.393" },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }